/**
 * Routes where users may be unauthenticated or mid-auth (invite, onboarding).
 * The auth interceptor must not hard-redirect away from these pages on 401,
 * or the invite policy UI will blink and bounce to /signin.
 */
export function isPublicAuthFlowPath(pathname: string): boolean {
  if (pathname.startsWith("/invite/")) {
    return true;
  }

  if (pathname.startsWith("/t/") || pathname.startsWith("/e/") || pathname.startsWith("/ingresso/")) {
    return true;
  }

  if (pathname === "/updates" || pathname.startsWith("/updates/")) {
    return true;
  }

  if (
    pathname.startsWith("/social/experiences/") ||
    pathname.startsWith("/social/questions/") ||
    pathname.startsWith("/social/u/")
  ) {
    return true;
  }

  if (
    pathname === "/onboarding/medium" ||
    pathname.startsWith("/onboarding/medium/")
  ) {
    return true;
  }

  if (
    pathname === "/onboarding/terreiro" ||
    pathname.startsWith("/onboarding/terreiro/")
  ) {
    return true;
  }

  return false;
}
